import { Fragment, useContext, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useDispatch, useSelector } from 'react-redux'
import { addItem, itemsCartSelect, minusItem, removeItem, totalCountSelect, totalPriceSelect } from '../../redux/slices/cartSlice'
import { AppContext } from '../../App'
import { useRef } from 'react'
import { useEffect } from 'react'

const ListTypes=['', 'універсально', 'для чоловіків', 'для жінок']
export default function Cart() {
   const {open, setOpen} = useContext(AppContext)

  const itemsCart = useSelector(itemsCartSelect)

  const totalPrice = useSelector(totalPriceSelect)

  const dispatch = useDispatch()

  const isMounted = useRef(false)
  
  useEffect(() => {
    if (isMounted.current) {
      const jsonItems = JSON.stringify(itemsCart)
      localStorage.setItem('cart', jsonItems)
    }
    isMounted.current = true
    
  }, [itemsCart])
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                    <div className="flex-1 overflow-y-auto py-6 px-4 sm:px-6">
                      <div className="flex items-start justify-between">
                        <Dialog.Title className="text-lg font-medium text-gray-900">Shopping cart</Dialog.Title>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="-m-2 p-2 text-gray-400 hover:text-gray-500"
                            onClick={() => setOpen(false)}
                          >
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>

                      <div className="mt-8">
                        <div className="flow-root">
                          <ul role="list" className="-my-6 divide-y divide-gray-200">
                            {itemsCart.length < 1 ? <div className="flex justify-around mt-10 text-base font-medium text-gray-500">
                              <p>You have not added any products yet!</p> </div>: 
                            itemsCart.map((product) => (
                              <li key={product.id} className="flex py-6">
                                <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                                  <img
                                    src={product.imageUrl}
                                    alt={product.title}
                                    className="h-full w-full object-cover object-center"
                                  />
                                </div>

                                <div className="ml-4 flex flex-1 flex-col">
                                  <div>
                                    <div className="flex justify-between text-base font-medium text-gray-900">
                                      <h3>
                                        <a href='/'>{product.title}</a>
                                      </h3>
                                      <p className="ml-4">{product.price * product.count}₴</p>
                                    </div>
                                    <p className="mt-1 text-sm text-gray-500">{ListTypes[product.types]}</p>
                                  </div>
                                  <div className="flex flex-1 items-end justify-between text-sm">
                                  

                                    <div className="flex">
                                      <button
                                      
                                        onClick={product.count > 1 ? () => dispatch(minusItem(product.id)) : () => dispatch(removeItem(product.id)) }
                                        type="button"
                                        className="font-large pr-4 text-4xl text-rose-300 hover:text-rose-200"
                                      >
                                        -
                                      </button>
                                     <span className='pr-4 text-4xl text-gray-500 '>{product.count}</span> 
                                      <button
                                        onClick={() => dispatch(addItem(product))}
                                        type="button"
                                        className="font-large pr-4 text-4xl text-rose-300 hover:text-rose-200"
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                      <div className="flex justify-between text-base font-medium text-gray-900">
                        <p>Subtotal</p>
                        <p>{totalPrice}₴</p>
                      </div>
                      <p className="mt-0.5 text-sm text-gray-500">Shipping and taxes calculated at checkout.</p>
                      <div className="mt-6">
                        <a
                          href="#"
                          className="flex items-center justify-center rounded-md border border-transparent bg-rose-400 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-rose-400"
                        >
                          Checkout
                        </a>
                      </div>
                      <div className="mt-6 flex justify-center text-center text-sm text-gray-500">
                        <p>
                          or
                          <button
                            type="button"
                            className="font-medium text-rose-600 hover:text-rose-500"
                            onClick={() => setOpen(false)}
                          >
                            Continue Shopping
                            <span aria-hidden="true"> &rarr;</span>
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}